const paymentType: string[] = ['pre_payment', 'invoice_payment'];
export default paymentType;
